import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ImagingRequestOrderDetailsModalComponent } from '../imaging-request-order-details-modal/imaging-request-order-details-modal.component';

@Component({
    selector: 'app-imaging-request-orders-details',
    templateUrl: './imaging-request-orders-details.component.html',
    styleUrl: './imaging-request-orders-details.component.scss'
})
export class ImagingRequestOrdersDetailsComponent {
    @Input()
    orders: OrderDetailsRow[];

    constructor(private readonly dialog: MatDialog) {}

    viewReport(accessionNumber: string): void {
        const orderWithReport = this.orders.find(order => order.accessionNumber === accessionNumber);

        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '450px';
        dialogConfig.height = '600px';
        dialogConfig.maxHeight = '95vh';
        dialogConfig.restoreFocus = true;
        dialogConfig.disableClose = false;
        dialogConfig.panelClass = ['draggable-dialog-container', 'resize-dialog', 'dialog-position-center'];
        dialogConfig.backdropClass = 'general-dialog-backdrop';
        dialogConfig.autoFocus = true;
        dialogConfig.data = orderWithReport;

        this.dialog.open(ImagingRequestOrderDetailsModalComponent, dialogConfig);
    }
}

export interface OrderDetailsRow {
    accessionNumber: string;
    modality: string;
    studyDescription: string;
    statusDescription?: string;
    statusDescriptionClass?: string;
    reportText?: string;
    signTime?: string;
}
